import React from 'react';

import { ProdStackManagerEmailConfirm } from 'containers/ProdStackManager/ProdStackManagerEmailConfirm';
import { ProdStackManagerClientInfoForm } from 'containers/ProdStackManager/ProdStackManagerClientInfoForm';
import { useAppState } from 'hooks/useAppState';
import { useAppDispatcher } from 'hooks/useAppDispatcher';
import { ProdStackManagerFinish } from 'containers/ProdStackManager/ProdStackManagerFinish';
import { FadeAnimationComponent } from 'design/fadeAnimationComponents';
import { ProdStackManagerContentLayoutComponent } from 'design/prodStackManagerLayout';
import { useProdStackManagerDataProcess } from 'hooks/useProdStackManagerDataProcess';

export const ProdStackManagerContentAuthorized = () => {
  useProdStackManagerDataProcess();

  const { prodStackManagerCurrentStep: currentStep } = useAppState();

  const dispatch = useAppDispatcher();

  const handleStepSubmitSucceed = React.useCallback(() => {
    dispatch({
      name: 'ProdStackManager__StepSubmitSucceed',
    });
  }, [dispatch]);

  const content = React.useMemo(() => {
    switch (currentStep) {
      case 0:
        return (
          <ProdStackManagerEmailConfirm
            onSubmitSucceed={handleStepSubmitSucceed}
          />
        );
      case 1:
        return (
          <ProdStackManagerClientInfoForm
            onSubmitSucceed={handleStepSubmitSucceed}
          />
        );
      case 2:
        return <ProdStackManagerFinish />;
      default:
        return null;
    }
  }, [currentStep, handleStepSubmitSucceed]);

  return (
    <FadeAnimationComponent trigger={currentStep}>
      <ProdStackManagerContentLayoutComponent>
        {content}
      </ProdStackManagerContentLayoutComponent>
    </FadeAnimationComponent>
  );
};
